import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { fromArrayToCSV } from '@trukt/utils/fromArrayToCSV';
import { AxiosInstance, AxiosPromise } from 'axios';
import { TerminalBulkService, TerminalContactService } from './services';
import {
  CreateTerminalRequest,
  CreateTerminalResponse,
  MergeTerminalsRequest,
  MergeTerminalsResponse,
  SearchTerminalsRequest,
  SearchTerminalsResponse,
  GetTerminalRequest,
  GetTerminalResponse,
  TerminalUpdateResponse,
  TerminalUpdateRequest,
} from './TerminalService.types';
import { SimplePaginatedResults } from '@trukt/types/PaginatedResults';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';

export type TerminalGetTypesRequest = BaseRequest<Pick<PaginatedQueryParams, 'pg' | 'rc'>>;
export type TerminalGetTypesResponse = SimplePaginatedResults<{ type: string }>;

export class TerminalService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  contact: TerminalContactService;
  bulk: TerminalBulkService;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.contact = new TerminalContactService(instance);
    this.bulk = new TerminalBulkService(instance);
  }

  create(request: CreateTerminalRequest) {
    return this.instance.post<CreateTerminalResponse>('/terminals', request.body);
  }

  getById(request: GetTerminalRequest) {
    return this.instance.get<GetTerminalResponse>(`/terminals/${request.guid}`);
  }

  getTypes({ queryParams }: TerminalGetTypesRequest) {
    return this.instance.get<TerminalGetTypesResponse>('/terminals/locations', {
      params: queryParams,
    });
  }

  search(request: SearchTerminalsRequest) {
    return this.instance.get<SearchTerminalsResponse>('/terminals', {
      params: { ...request.queryParams, search: fromArrayToCSV(request.queryParams.search) },
    });
  }

  update(request: TerminalUpdateRequest) {
    return this.instance.patch<TerminalUpdateResponse>(
      `/terminals/${request.routeParams.id}`,
      request.body,
    );
  }

  delete(request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  merge(request: MergeTerminalsRequest) {
    return this.instance.put<MergeTerminalsResponse>(
      `/terminals/${request.routeParams.guid}/merge`,
      request.body,
    );
  }
}
